module.exports = __webpack_public_path__ + "static/media/adminLogo.2397535b.svg";